import { rbacManagementActions } from "../../constants/actionTypes";

const getRolesListData = (data) => ({
  type: rbacManagementActions.ROLESLISTGETDATA,
  payload: data,
});

const setRolesListData = (data) => ({
  type: rbacManagementActions.ROLESLISTSETDATA,
  payload: data,
});

const setRolesListError = (data) => ({
  type: rbacManagementActions.ROLESLISTSETERROR,
  payload: data,
});

const getPermissionsListData = (data) => ({
  type: rbacManagementActions.PERMISSIONSLISTGETDATA,
  payload: data,
});

const setPermissionsListData = (data) => ({
  type: rbacManagementActions.PERMISSIONSLISTSETDATA,
  payload: data,
});

const setPermissionsListError = (data) => ({
  type: rbacManagementActions.PERMISSIONSLISTSETERROR,
  payload: data,
});

const getRolePermissionsData = (data) => ({
  type: rbacManagementActions.ROLEPERMISSIONSGETDATA,
  payload: data,
});

const setRolePermissionsData = (data) => ({
  type: rbacManagementActions.ROLEPERMISSIONSSETDATA,
  payload: data,
});

const setRolePermissionsError = (data) => ({
  type: rbacManagementActions.ROLEPERMISSIONSSETERROR,
  payload: data,
});

const rolePermissionsEditRequest = (data) => ({
  type: rbacManagementActions.ROLEPERMISSIONSEDITREQUEST,
  payload: data,
});

const rolePermissionsEditSuccess = (data) => ({
  type: rbacManagementActions.ROLEPERMISSIONSEDITSUCCESS,
  payload: data,
});

const rolePermissionsEditError = (data) => ({
  type: rbacManagementActions.ROLEPERMISSIONSEDITERROR,
  payload: data,
});

const setNewRoleRequest = (data) => {
  return {
    type: rbacManagementActions.CREATENEWROLEREQUEST,
    payload: data,
  };
};

const setNewRoleSuccess = (data) => {
  return {
    type: rbacManagementActions.CREATENEWROLESUCCESS,
    payload: data,
  };
};

const setNewRoleError = (data) => {
  return {
    type: rbacManagementActions.CREATENEWROLEERROR,
    payload: data,
  };
};

const getCloneRolesRequest = () => {
  return {
    type: rbacManagementActions.FETCH_CLONE_ROLES,
  };
};

const setUserActionData = (data) => {
  return {
    type: rbacManagementActions.USER_ACTION_SUCCESS,
    payload: data,
  };
};

const errorUserActionData = (data) => {
  return {
    type: rbacManagementActions.ERROR_USER_ACTION_DATA,
    payload: data,
  };
};

const setDeleteActionData = (data) => {
  return {
    type: rbacManagementActions.DELETE_ACTION_DATA,
    payload: data,
  };
};

const setCloneRolesList = (data) => {
  return {
    type: rbacManagementActions.SET_CLONE_ROLES,
    payload: data,
  };
};

const deleteRoleRequest = (data) => {
  return {
    type: rbacManagementActions.DELETE_ROLE,
    payload: data,
  };
};

const deleteRoleError = (data) => {
  return {
    type: rbacManagementActions.DELETE_ROLE_ERROR,
    payload: data,
  };
};

const getResourcePermissions = (data) => {
  return {
    type: rbacManagementActions.GET_RESOURCE_PERMISSIONS,
    payload: data,
  };
};

const setResourcePermissions = (data) => {
  return {
    type: rbacManagementActions.SET_RESOURCE_PERMISSIONS,
    payload: data,
  };
};

const setResourcePermissionError = (data) => {
  return {
    type: rbacManagementActions.SET_RESOURCE_PERMISSIONS_ERROR,
    payload: data,
  };
};

export {
  getRolesListData,
  setRolesListData,
  setRolesListError,
  getPermissionsListData,
  setPermissionsListError,
  setPermissionsListData,
  getRolePermissionsData,
  setRolePermissionsData,
  setRolePermissionsError,
  rolePermissionsEditRequest,
  rolePermissionsEditSuccess,
  rolePermissionsEditError,
  setNewRoleRequest,
  setNewRoleSuccess,
  setNewRoleError,
  getCloneRolesRequest,
  setCloneRolesList,
  setUserActionData,
  deleteRoleRequest,
  deleteRoleError,
  getResourcePermissions,
  setResourcePermissions,
  setResourcePermissionError,
  errorUserActionData,
  setDeleteActionData,
};
